webpackJsonp([256317873200919],{

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/d-palmer.96441d29.png";

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hippocrates.24e5259a.png";

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/palmer.33abbfeb.png";

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: 2rem 0;\n  border-bottom: 1px solid #ccc;\n\n  &:last-of-type {\n    border: none;\n  }\n\n  display: flex;\n'], ['\n  padding: 2rem 0;\n  border-bottom: 1px solid #ccc;\n\n  &:last-of-type {\n    border: none;\n  }\n\n  display: flex;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  min-width: 160px;\n  width: 160px;\n'], ['\n  min-width: 160px;\n  width: 160px;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: 120px;\n'], ['\n  width: 120px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Lead = __webpack_require__(43);
	
	var _Lead2 = _interopRequireDefault(_Lead);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _hippocrates = __webpack_require__(497);
	
	var _hippocrates2 = _interopRequireDefault(_hippocrates);
	
	var _dPalmer = __webpack_require__(493);
	
	var _dPalmer2 = _interopRequireDefault(_dPalmer);
	
	var _palmer = __webpack_require__(499);
	
	var _palmer2 = _interopRequireDefault(_palmer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Origin = _styledComponents2.default.div(_templateObject);
	
	var ImageContainer = _styledComponents2.default.div(_templateObject2);
	
	var Img = _styledComponents2.default.img(_templateObject3);
	
	var Origins = function Origins() {
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'The Origins of Chiropractic'
	    ),
	    _react2.default.createElement(
	      _Lead2.default,
	      null,
	      'Chiropractic is by no means a new phenomenon. In today\'s society we think of pain relief through the intervention of surgery or drugs, but pain relief through the art of spinal manipulation stretches back thousands of years. The earliest records are of Asian decent but slightly later, perhaps the most documented founder of medicine as we know it, the Greek physician Hippocrates, quoted philosophies on physiology related to chiropractic, that we are only now, two thousand years later, beginning to understand.'
	    ),
	    _react2.default.createElement(
	      Origin,
	      null,
	      _react2.default.createElement(
	        ImageContainer,
	        null,
	        _react2.default.createElement(Img, { src: _hippocrates2.default, alt: 'Hippocrates' })
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'In 370 BC; Hippocrates is known to have said "Generally speaking all parts of the body that have function, if used in moderation and exercised in labours to which each is accustomed, become healthy and well developed and age slowly. But if unused and left idle become liable to disease, defective in growth and age quickly." In todays terms, this can be read as "use it or lose it"!'
	      )
	    ),
	    _react2.default.createElement(
	      Origin,
	      null,
	      _react2.default.createElement(
	        ImageContainer,
	        null,
	        _react2.default.createElement(Img, { src: _dPalmer2.default, alt: 'Daniel David Palmer' })
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'It wasn\'t until 1895 that Chiropractic as we know it today was born. American, Daniel David Palmer (DD Palmer), a \'magnetic healer\' at that time, carried out the first ever chiropractic adjustment on Harvey Lillard, the building janitor where Palmer worked. Lillard, who had been profoundly deaf for the previous 17 years, recalled to Palmer that he felt something give in his back whilst stooping; his loss of hearing following almost immediately.'
	      )
	    ),
	    _react2.default.createElement(
	      Origin,
	      null,
	      _react2.default.createElement(
	        ImageContainer,
	        null,
	        _react2.default.createElement(Img, { src: _palmer2.default, alt: 'Daniel David Palmer working on a patient' })
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Palmer examined Lillard and carried out a deliberate adjustment to a vertebra in his upper spine. Lillard had complained of pain in this region before the adjustment but shortly after the treatment his hearing began to return.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Palmer was not surprised by this result and later professed to have been working on the bio mechanics of spinal manipulation for some time. The dawn of spinal manipulation had begun and Palmer remembered its Greek origins by naming his technique Chiropractic; \'cheir\' meaning \'hand\' and \'praktikos\' meaning \'done by\' - hence, \'done by hand\'.'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Origins;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-origins-of-chiropractic-js-9f3a295f27cf3915acf6.js